var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as platformClient from './platformClient';
import { identify } from './eventService';
import * as Partners from '../constants/partners';
import { Constants } from '../constants/index';
import { CardApiClient } from './cardApiClient';
var usersUrls = {
    getCurrentUser: '/v1/clients/me',
    enableAutomaticRenewal: '/v2/users/enable_automatic_renewal',
    disableAutomaticRenewal: '/v2/users/disable_automatic_renewal'
};
var getCardActiveSubscription = function (user) {
    var activeCardSubscriptions = user.subscriptions.filter(function (subscription) {
        return subscription.product.name === 'card' && subscription.state !== 'canceled';
    });
    if (activeCardSubscriptions && activeCardSubscriptions.length === 1) {
        return activeCardSubscriptions[0];
    }
    // something went wrong
    console.warn('activeCardSubscriptions: ', activeCardSubscriptions && JSON.stringify(activeCardSubscriptions));
    return null;
};
var getContactCenterName = function (subscription) {
    var contactCenterId = subscription.contact_center_id;
    if (!contactCenterId) {
        return null;
    }
    var contactCenter = Constants.ContactCenter.find(function (contactCenter) { return contactCenter.id === contactCenterId; });
    return contactCenter ? contactCenter.name : null;
};
var getPartnerName = function (subscription) {
    return Partners.ARG.TELEFONICA.list.includes(subscription.partner.id)
        ? Partners.ARG.TELEFONICA.name
        : Partners.ARG.OTHER.name;
};
export function toUser(user) {
    var cardSubscription = getCardActiveSubscription(user);
    var partnerName = getPartnerName(cardSubscription);
    var contactCenterName = getContactCenterName(cardSubscription);
    return {
        firstName: user.first_name,
        lastName: user.last_name,
        id: parseInt(user.id, 10),
        langCode: 'es',
        email: user.email,
        createdAt: user.created_at,
        applicationSettings: user.settings && {
            applicationLogoUrl: user.settings.application_logo_url,
            logoBackgroundColor: user.settings.logo_background_color,
            termsAndConditionsUrl: user.settings.terms_and_conditions_url,
            addAdmins: user.settings.add_admins,
            logout: user.settings.logout,
            logoutRedirectUrl: user.settings.logout_redirect_url,
            buttonHelp: user.settings.button_help
        },
        shopIds: user.shop_ids,
        authorizations: user.authorizations,
        defaultCountry: user.default_country,
        accountId: user.account_id,
        partnerName: partnerName,
        impersonator: user.real_user && {
            id: user.real_user.id,
            email: user.real_user.email
        },
        subscriptionId: user.subscriptions[0].id,
        contactCenter: contactCenterName
    };
}
export function me() {
    return __awaiter(this, void 0, void 0, function () {
        var userFromAPI, formatUser, userParams;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, platformClient.getCurrentUser()];
                case 1:
                    userFromAPI = _a.sent();
                    formatUser = toUser(userFromAPI);
                    userParams = {
                        accountId: formatUser.accountId,
                        email: formatUser.email,
                        subscriptionId: formatUser.subscriptionId,
                        contactCenter: formatUser.contactCenter
                    };
                    identify(userParams, formatUser.impersonator);
                    return [2 /*return*/, formatUser];
            }
        });
    });
}
export function products() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, platformClient.getCurrentProducts()];
        });
    });
}
export function getCardUser() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, CardApiClient.get(usersUrls.getCurrentUser)];
        });
    });
}
